import api from '@/api/campaignCommissions';

const state = {
  all: [],
  current: null,
};

const getters = {
  campaignCommission: (state) => state.current,
};

const actions = {
  async fetchCampaignCommissions({ commit }, payload = {}) {
    const { data } = await api.list(payload);
    commit('setCampaignCommissions', data);
  },
  async getCampaignCommission({ commit }, id) {
    const { data } = await api.get(id);
    commit('setCurrentCampaignCommission', data);
    return data;
  },
  async createCampaignCommission({ commit }, payload) {
    const { data } = await api.create(payload);
    commit('upsertCampaignCommission', data);
    return data;
  },
  async updateCampaignCommission({ commit }, payload) {
    const { data } = await api.update(payload);
    commit('upsertCampaignCommission', data);
    return data;
  },
  async deleteCampaignCommission({ commit }, id) {
    await api.remove(id);
    commit('removeCampaignCommission', id);
  },
  clearCampaignCommissions({ commit }) {
    commit('resetCampaignCommissions');
  },
};

const mutations = {
  setCampaignCommissions(state, items) {
    state.all = items || [];
  },
  setCurrentCampaignCommission(state, item) {
    state.current = item ? { ...item } : null;
  },
  upsertCampaignCommission(state, item) {
    if (!item) {
      return;
    }

    const index = state.all.findIndex((x) => x.id === item.id);
    if (index > -1) {
      state.all.splice(index, 1, item);
    } else {
      state.all.push(item);
    }

    state.current = { ...item };
  },
  removeCampaignCommission(state, id) {
    state.all = state.all.filter((x) => x.id !== id);
  },
  resetCampaignCommissions(state) {
    state.all = [];
    state.current = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
